import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-success-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  template: `
    <div class="success-container">
      <h2>¡Alojamiento creado con éxito! 🎉</h2>
      <p>¿Qué deseas hacer ahora?</p>

      <div class="buttons">
        <button mat-raised-button color="primary" (click)="goToAdmin()">
          Ir a Administrar
        </button>

        <button mat-raised-button color="accent" (click)="createAnother()">
          Crear otro Alojamiento
        </button>
      </div>
    </div>
  `,
  styles: [`
    .success-container {
      text-align: center;
      padding: 20px;
      max-width: 350px;
    }
    .buttons {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 20px;
    }
  `]
})
export class SuccessDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<SuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  goToAdmin() {
    this.dialogRef.close('admin');
  }

  createAnother() {
    this.dialogRef.close('new');
  }
}
